__webpack_require__.p = "/vuejs/";